/** Capability checks do not enumerate devices, open cameras or request permission. */
export function hasSignatureCameraSupport(doc: Document = document): boolean {
  const win = doc.defaultView;
  const policyDoc = doc as Document & { permissionsPolicy?: { allowsFeature(name: string): boolean }; featurePolicy?: { allowsFeature(name: string): boolean } };
  const policy = policyDoc.permissionsPolicy ?? policyDoc.featurePolicy;
  return !!win?.isSecureContext && typeof win.navigator.mediaDevices?.getUserMedia === 'function'
    && (!policy || policy.allowsFeature('camera'));
}

export function initializeSignatureCapabilities(doc: Document = document): () => void {
  const camera = doc.getElementById('photoSignature');
  const upload = doc.getElementById('uploadSignature');
  const probe = doc.createElement('input'); probe.type = 'file';
  const win = doc.defaultView!;
  upload?.classList.toggle('hidden', !('files' in probe) || typeof win.FileReader !== 'function');
  const render = () => camera?.classList.toggle('hidden', !hasSignatureCameraSupport(doc));
  render();
  let disposed = false;
  let permission: PermissionStatus | undefined;
  const update = () => camera?.classList.toggle('hidden', !hasSignatureCameraSupport(doc) || permission?.state === 'denied');
  if (hasSignatureCameraSupport(doc) && win.navigator.permissions?.query) {
    // Query only. Older browsers may not recognize the camera permission name.
    void win.navigator.permissions.query({ name: 'camera' as PermissionName }).then(status => {
      if (disposed) return;
      permission = status; update(); status.addEventListener('change', update);
    }).catch(() => { /* Feature detection remains available without permission status. */ });
  }
  return () => { disposed = true; permission?.removeEventListener('change', update); };
}
